// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__51D7t","volume-slider":"style_volume-slider__U5Gmm","volume-level":"style_volume-level__i+OIA","visible":"style_visible__Acpz-"};